// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__29Tdy","messages":"Chat_messages___YKNk","dateDivider":"Chat_dateDivider__1lumb"};